import moment from "moment"

export enum BUDDY_STATUS {
  ACCEPTED = "accepted",
  DENIED = "denied",
  NEW = "new",
  BLANK = "",
  EITHER = "either",
}

function isSupportedAppUrl(inputText: string): boolean {
  const prefixes: string[] = ["http", "www", "letshang.co", "letshang.app"]
  return prefixes.some((prefix: string) => inputText.startsWith(prefix))
}

const isDev = (): boolean => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === "development"
}

const reviewedBuddyStatuses = Object.values(BUDDY_STATUS).filter(
  (buddyStatus) => {
    const isReviewed =
      buddyStatus !== BUDDY_STATUS.NEW && buddyStatus !== BUDDY_STATUS.BLANK
    // if (isReviewed) {
    //   console.log(
    //     `buddyStatus '${buddyStatus}' != '${EBUDDIES_STATUS.NEW}' isReviewed`,
    //   )
    // }
    return isReviewed
  },
)

const GenderPronounMap: Record<string, string> = {
  female: "She / Her",
  male: "He / Him",
  "non-binary": "They / Them",
  "rather-not-to-say": "Other",
}

const GenderMap: Record<string, string> = {
  female: "Female",
  male: "Male",
  "non-binary": "Non-Binary",
  "rather-not-to-say": "Rather not say",
}

function convertImageToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = () => {
      resolve(reader.result) // This is the Base64 string
    }

    reader.onerror = (error) => {
      reject(error)
    }
  })
}

function ensureLetsHangHttps(url: string): string {
  const needsHttps =
    /letshang\.(info|app)/i.test(url) && !/^https?:\/\//i.test(url)
  return needsHttps ? `https://${url}` : url
}

const safeJsonParse = (str: string) => {
  try {
    return JSON.parse(str)
  } catch {
    return {}
  }
}

const getGeneralAddress = (fullAddress: string) => {
  // Check if the input is a string and not empty
  if (typeof fullAddress !== "string" || fullAddress.trim() === "") {
    return "Hidden" // Default value for invalid input
  }
  // Split the address into parts
  const parts = fullAddress.split(",").map((part) => part.trim())
  // Check if the array has at least two parts (street and city)
  if (parts.length < 2) {
    return "Hidden" // Default for incomplete addresses
  }
  // Remove the first numeric component from the street part if it looks like a building number
  let street = parts[0]
  const streetParts = street.split(" ")
  if (streetParts.length > 1 && /^\d+$/.test(streetParts[0])) {
    streetParts.shift() // Remove the first element if it's purely numeric
  }
  street = streetParts.join(" ")

  const city = parts[1]

  // Combine street and city to get a general address
  return `${street}, ${city}`
}

const createEventDefaultDateTime = () => {
  const now = moment()
  // move to the next full hour (even if that's later today)
  const nextHour = now.clone().add(2, "hour").startOf("hour")

  const initialStartDate = nextHour.format("MMMM DD YYYY")
  const initialStartTime = nextHour.format("hh:00 A")
  const endMoment = nextHour.clone().add(1, "hour")
  const initialEndDate = endMoment.format("MMMM DD YYYY")
  const initialEndTime = endMoment.format("hh:00 A")

  return {
    initialStartDate,
    initialStartTime,
    initialEndDate,
    initialEndTime,
  }
}

function convertToUTC(dateTimeStr: string) {
  return moment(dateTimeStr, "MMMM DD YYYY hh:mm A").utc().toISOString()
}

export {
  isSupportedAppUrl,
  isDev,
  reviewedBuddyStatuses,
  GenderPronounMap,
  GenderMap,
  convertImageToBase64,
  ensureLetsHangHttps,
  safeJsonParse,
  getGeneralAddress,
  createEventDefaultDateTime,
  convertToUTC,
}
